/*
 * Copyright (c) 2026. Bolmate B.V.
 */

import {useEffect, useState} from 'react';
import {createSnooze, SnoozeConfig, snoozeKey} from '../util/snoozeUtil';

export interface UseSnooze {
    suppressed: boolean;
    dismiss: VoidFunction;
    reset: VoidFunction;
}

export function useSnooze(config: SnoozeConfig | null | undefined): UseSnooze {
    const key = config ? snoozeKey(config.featureKey, config.scope) : null;
    const cooldownsKey = config?.cooldowns?.join(',') ?? '';

    const [suppressed, setSuppressed] = useState(() =>
        key ? createSnooze(key, config?.cooldowns).isSnoozed() : false
    );

    function dismiss() {
        if (!key) return;
        createSnooze(key, config?.cooldowns).recordDismissal();
        setSuppressed(true);
    }

    function reset() {
        if (!key) return;
        createSnooze(key, config?.cooldowns).reset();
        setSuppressed(false);
    }

    useEffect(() => {
        const cooldowns = cooldownsKey ? cooldownsKey.split(',').map(Number) : undefined;
        setSuppressed(key ? createSnooze(key, cooldowns).isSnoozed() : false);
    }, [key, cooldownsKey]);

    return {suppressed, dismiss, reset};
}
